export var REWARD_CENTER_EVENT_TYPES = {
  ENTER_REWARD_CENTER_SCREEN: 'ENTER_REWARD_CENTER_SCREEN',
  OPEN_REWARD_CENTER_CATEGORY: 'OPEN_REWARD_CENTER_CATEGORY',
  OPEN_REWARD_CENTER_OFFER: 'OPEN_REWARD_CENTER_OFFER',
  RC_REDEEM_VIEWED: 'RC_REDEEM_VIEWED',
  RC_REDEEM_OFFER_VIEWED: 'RC_REDEEM_OFFER_VIEWED',
  RC_REDEEM_ATTEMPTED: 'RC_REDEEM_ATTEMPTED',
  RC_REDEEM_SUCCESS: 'RC_REDEEM_SUCCESS',
  RC_REDEEM_FAILED: 'RC_REDEEM_FAILED'
};